/**
 * BudgetTransactionTypeService
 * Service for BudgetTransactionType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetTransactionType CRUD operations */
export class BudgetTransactionTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetTransactionTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetTransactionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetTransactionTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetTransactionTypeService.BASE_PATH = 'api/budgettransactiontypes';
//# sourceMappingURL=BudgetTransactionTypeService.js.map